export class AnimicalState {
  static UNDEFINED = -1;
  static IN_CALM = 0;
  static NERVOUS = 1;
  static VERY_NERVOUS = 2;
}
